<template>
  <div class="footer">
    <!-- <div class="footer-logo"></div> -->
    <div class="footer-copyright">
      <p class="footer-title">友情链接</p>
      <div class="footer-content footer-border">
        <span> <a href="https://cdsgxq.sczwfw.gov.cn/?areaCode=510109000000" target="_blank"> 高新区政务中心 </a></span>
        <span> <a href="https://cdstfxq.sczwfw.gov.cn/?areaCode=510110000000" target="_blank"> 天府新区政务中心 </a></span>
        <span> <a href="https://cdswhq.sczwfw.gov.cn/?areaCode=510107000000" target="_blank"> 武侯区政务中心</a></span>
      </div>
      
      <div class="footer-info flexBetween footer-border">
        <div class="footer-info-use flex">
          <div>
            <p class="footer-title">企业服务</p>
            <div class="footer-content flexColumn">
              <!-- <router-link tag="li" to="/index/jobPosting" ></router-link> -->
              <span @click="openPublishPositionWeb">职位发布</span>
              <span @click="openPublishPositionWeb">公众号广告</span>
              <!-- <span></span> -->
            </div>
          </div>

          <div>
            <p class="footer-title">使用与帮助</p>
            <div class="footer-content flexColumn">
              <router-link tag="li" to="/index/jobPosting" >协议与规则</router-link>
              <!-- <span></span> -->
              <!-- <span></span> -->
              <router-link tag="li" to="/index/userAgreement" >使用帮助</router-link>
            </div>
          </div>

          <div>
            <p class="footer-title">企业证件</p>
            <div class="footer-content flexColumn">
              <!-- <router-link tag="li" to="/index/jobPosting" ></router-link> -->
              <router-link tag="li" to="/index/resource" >人力资源服务许可证</router-link>
              <router-link tag="li" to="/index/bussness" >营业执照</router-link>
              <!-- <span></span> -->
            </div>
          </div>

        </div>

        <div class="footer-info-contact">
          <p class="footer-title">关注或联系我们</p>
          <div class="flex footer-content">
            <!-- <div v-for="item in contactList" :key="item.id" class="flexColumn">
              <img :src="Bimg"/>
              <span>{{item.title}}</span>
            </div> -->

            <div class="flexColumn">
              <img :src="Simg"/>
              <span>内推圈公众号</span>
            </div>
            <div class="flexColumn">
              <img :src="Cimg"/>
              <span>C端微信小程序</span>
            </div>
            <div class="flexColumn">
              <img :src="Bimg"/>
              <span>B端微信小程序</span>
            </div>
          </div>

        </div>
      </div>
      <a class="copyright flexCentet" rel="external" href="https://beian.miit.gov.cn">© 2020 IT内推圈 蜀ICP备17040058号-1 不支持IE浏览器</a>
    </div>
  </div>
</template>

<script>
import Bimg from '../../assets/images/weichatCode/B.jpg';
import Cimg from '../../assets/images/weichatCode/c.jpg';
import Simg from '../../assets/images/weichatCode/subscribe.jpg';
export default {
  
  data() {
    return {
      contactList:[
        {id:1,title:"内推圈公众号",imgUrl:this.Simg},
        {id:2,title:"C端微信小程序",imgUrl:this.Cimg},
        {id:3,title:"B端微信小程序",imgUrl:this.Bimg}
      ],
    };
  },
  methods:{
    openPublishPositionWeb() {
      window.open("https://www.selfhelp.itneituiquan.com", "_blank");
    }
  },
  computed: {
    Bimg() {
      return Bimg;
    },
    Cimg() {
      return Cimg;
    },
    Simg() {
      return Simg;
    },
    
  }
};
</script>

<style lang="less" scoped>
.footer {
  background-color:  #0B2342;
  &-logo {
    height: 60px;
    line-height: 60px;
    background: #fff url("../../assets/images/logo_74.png") no-repeat center
      center;
  }
  &-copyright {
    width: 1280px;
    padding: 40px 0 26px;
    margin: 0 auto;
    // height: 40px;
    // line-height: 40px;
    background-color: #0B2342;
    color: #fff;
    // text-align: center;
  }
  &-title{
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 30px;
    padding-bottom: 6px;
  }
  &-border{
    border-bottom: 1px solid rgba(255, 255, 255, .3);
    padding-bottom: 24px;
  }
  
  &-content{
    align-items: flex-start;
    span{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, .8);
      padding-right: 40px;
      line-height: 30px;
      cursor: pointer;
      a{
        color: #fff;
      }
    }
    li{
      list-style: none;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, .8);
      padding-right: 40px;
      line-height: 30px;
      cursor: pointer;
    }
  }
  &-info{
    padding-top: 24px;
    &-contact{
      span{
        padding: 0;
      }
      .flexColumn{
        align-items: center;
        img{
          width: 72px;
          height: 72px;
        }
        &:nth-child(2){
          padding:0 40px;
        }
        
      }
    }
    
    
  }
  .copyright{
    padding-top: 24px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
}

</style>
